//Polyfills
import 'whatwg-fetch'
import PolyfillArrayFrom from './vendors/polyfill-arrayfrom';
import Promise from './vendors/polyfill-promise';
import './vendors/polyfill-array-methods';
import 'es6-promise/auto';
import './vendors/polyfill-isInteger';
import './vendors/polyfill-object-assign';

if (!Array.from) {
    window.PolyfillArrayFrom = PolyfillArrayFrom;
}
if (!window.Promise) {
    window.Promise = Promise;
}

import Parallax from './modules/parallax';
import Accordion from './modules/accordion';
import SmoothScroll from './modules/smoothScroll';
import Search from './modules/search';
import SearchSuggest from './modules/searchsuggest';
import Basket from './modules/basket';
import PublicationPage from './modules/publicationPage';
import Checkout from './modules/checkout';
import FormGenerel from './modules/formGenerel';
import Share from './modules/share';
import ImageMagnifier from './modules/imageMagnifier';
import './modules/cardsCarousel';
import MediaPopup from './modules/mediaPopup.js';
import Dropdown from './modules/dropdown';


new Parallax();
new Accordion();
new SmoothScroll();
new Search();
new SearchSuggest();
new Basket();
new PublicationPage();
new Checkout();
new FormGenerel();
new Share();
new MediaPopup();


import hoverIntent from './vendors/hoverIntent';
import navigation from './modules/navigation';
import bootpag from './vendors/bootpag.min';
import products from './modules/productsOverview';
import product from './modules/productPage';
import courses from './modules/coursesOverview';
import calendar from './modules/coursesCalendar';
import cookieBanner from './modules/cookieBanner';
import fullWidthBlocks from './modules/fullWidthBlocks';
import slick from 'slick-carousel';
import ntiSlickSlider from './modules/slickCarousel';

import './components'




$(".flexnav").flexNav();
document.addEventListener('DOMContentLoaded', () => {
    Dropdown.initAll('.dropdown-toggle', { hover: false });     
});